var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37414 7.76508C1.3186 7.9147 1.3186 8.07929 1.37414 8.22891C1.91507 9.5405 2.83326 10.662 4.01232 11.4511C5.19137 12.2402 6.57819 12.6615 7.99695 12.6615C9.41571 12.6615 10.8025 12.2402 11.9816 11.4511C13.1606 10.662 14.0788 9.5405 14.6198 8.22891C14.6753 8.07929 14.6753 7.9147 14.6198 7.76508C14.0788 6.45349 13.1606 5.33204 11.9816 4.54291C10.8025 3.75379 9.41571 3.33252 7.99695 3.33252C6.57819 3.33252 5.19137 3.75379 4.01232 4.54291C2.83326 5.33204 1.91507 6.45349 1.37414 7.76508Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99695 9.99628C9.1011 9.99628 9.99619 9.10119 9.99619 7.99704C9.99619 6.89289 9.1011 5.9978 7.99695 5.9978C6.8928 5.9978 5.99771 6.89289 5.99771 7.99704C5.99771 9.10119 6.8928 9.99628 7.99695 9.99628Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9939,
    height: 15.9939,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBlack);
export default __webpack_public_path__ + "static/media/profileBlack.fcf698cf989e99dfd5314a18211ce110.svg";
export { ForwardRef as ReactComponent };